import { Link } from "react-router-dom";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

const DashboardAdmin = () => {
  return (
    <>
      <SiteTitle title="داشبورد مدیریت" />

      <section className="section kf-services section-bg">
        <div className="container">
          <div className="kf-services-items justify-content-center row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div className="kf-services-item" data-animate="active">
                <div className="image kf-image-hover">
                  <Link to="/admin/user">
                    <img src="/assets/images/service1.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-users" />
                  </div>
                  <h5 className="name">مدیریت کاربران</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div className="kf-services-item" data-animate="active">
                <div className="image kf-image-hover">
                  <Link to="/admin/category">
                    <img src="/assets/images/service2.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-coffee" />
                  </div>
                  <h5 className="name">مدیریت دسته بندی ها</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div className="kf-services-item" data-animate="active">
                <div className="image kf-image-hover">
                  <Link to="/admin/menu">
                    <img src="/assets/images/service3.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-glass-cheers" />
                  </div>
                  <h5 className="name">مدیریت منو</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div className="kf-services-item" data-animate="active">
                <div className="image kf-image-hover">
                  <Link to="/admin/image">
                    <img src="/assets/images/menu3.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-images" />
                  </div>
                  <h5 className="name">مدیریت تصاویر</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div className="kf-services-item" data-animate="active">
                <div className="image kf-image-hover">
                  <Link to="/admin/setting">
                    <img src="/assets/images/menu4.jpg" alt="image" />
                  </Link>
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-cog" />
                  </div>
                  <h5 className="name">تنظیمات</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DashboardAdmin;
